import React from 'react';
import DashboardToolbarCookingMethod from './DashboardToolbarCookingMethod';
import DashboardToolbarProducts from './DashboardToolbarProducts';
import DashboardToolbarInterval from './DashboardToolbarInterval';
import DashboardToolbarDateTimePicker from './DashboardToolbarDateTimePicker';

const DashboardToolbar = ({ changedSearch, setChangedSearch, materials }) => {
  return (
    <div className="page-toolbar mt-16">
      <div className="left-bar">
        <DashboardToolbarCookingMethod />
        <DashboardToolbarProducts materials={materials} />
        <DashboardToolbarInterval />
      </div>
    
      <div className="right-bar">
        <DashboardToolbarDateTimePicker changedSearch={changedSearch} setChangedSearch={setChangedSearch} />
      </div>
    </div>
  );
};

export default DashboardToolbar;